<template>
    <div v-if="$vuetify.breakpoint.xs">
        <v-btn
            @click="prevQuestion"
            fab
            small
            bottom
            right
            fixed
            icon
            class="mr-12 primary--text"
            :disabled="currentNumber === 1"
        >
            <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <v-btn
            @click="nextQuestion"
            fab
            small
            bottom
            right
            fixed
            icon
            class="primary white--text"
            :disabled="currentNumber === totalNumber"
        >
            <v-icon>mdi-chevron-right</v-icon>
        </v-btn>

        <v-btn
            @click.stop="finish"
            fixed
            bottom
            left
            text
            :class="doneClass"
            :loading="$store.get('loader/loading', 'finishing')"
        >
            <v-icon left>mdi-check</v-icon>
            Selesai
        </v-btn>
    </div>
</template>

<script>
import finishButton from './finishButton'
import { call } from 'vuex-pathify'

export default {
    computed: {
        currentNumber() {
            return this.$store.get('tryout/activeQuestionIdx') + 1
        },

        totalNumber() {
            return this.$store.get('tryout/questions').length
        },

        doneClass: finishButton.doneClass,
    },

    methods: {
        ...call('tryout', ['prevQuestion', 'nextQuestion']),

        finish: finishButton.finish,
    },
}
</script>
